import { render } from "./BlockText.vue?vue&type=template&id=3b64faa0"
import script from "./BlockText.vue?vue&type=script&lang=js"
export * from "./BlockText.vue?vue&type=script&lang=js"
script.render = render

export default script